import React from 'react';
import Rol from '../../components/rol/Rol';
import Layout from '../../components/layout/Layout';

const RolPage = () => {
    return ( <Layout children={<Rol />} /> )
}

export default RolPage